<template>
  <section class="section--hero">
    <div class="section__container text-left">
      <div class="nav-indicator">
        <nav-indicator :nav-indicator="navIndicator" />
      </div>
      <v-row class="section__row" align="center">
        <v-col cols="12" :md="imageName ? '7' : '12'" class="section__col">
          <div class="text__container">
            <div class="job-post__tags text-left" v-if="department && department.length">
              <v-chip
                v-for="cat in department"
                :key="cat.name"
                :color="cat.color || '#E0E0E0'"
                :text-color="cat.color || '#000000'"
                class="job-post__skill-chip mr-2 mt-2"
                size="large"
              >
                {{ cat.name }}
              </v-chip>
            </div>
            <template v-if="reverseOrder">
              <h1 class="section__title" v-html="title" v-if="title"></h1>
              <p
                class="section__subtitle mt-4"
                v-if="subTitle"
                v-html="subTitle"
              ></p>
            </template>
            <template v-else>
              <p
                class="section__subtitle"
                v-if="subTitle"
                v-html="subTitle"
              ></p>
              <h1 class="section__title mt-4" v-html="title" v-if="title"></h1>
            </template>
            
            <div class="job-post__tags text-left" v-if="hardSkills && hardSkills.length">
              <v-chip
                v-for="skill in hardSkills"
                :key="skill.label"
                variant="outlined"
                class="job-post__skill-chip mr-3 mt-2 mb-2"
                size="small"
                style="border-color: #7c7979;"
              >
                {{ skill.label }}
              </v-chip>
            </div>
            <div class="job-post__details text-left" v-if="jobDetails">
              <span class="job-post__detail" v-if="jobDetails.type">
                <v-icon small class="mr-1" v-if="jobDetails.type">mdi-clock-outline</v-icon>
                {{ jobDetails.type }}
              </span>
              <span class="job-post__detail" v-if="jobDetails.workMode">
                <v-icon small class="mr-1" v-if="jobDetails.workMode">mdi-radiobox-marked</v-icon>
                {{ jobDetails.workMode }}
              </span>
              <span class="job-post__detail" v-if="jobDetails.location">
                <v-icon small class="mr-1" v-if="jobDetails.location">mdi-map-marker</v-icon>
                {{ jobDetails.location }}
              </span>
            </div>
            <p
              class="section__description m500 mt-3 mb-7"
              v-if="description"
              v-html="description"
            ></p>
            <a
              class="hero__btn m600"
              variant="text"
              elevation="0"
              v-if="hasApplyButton"
              :href="applyButtonUrl"
              append-icon="mdi-open-in-new"
            >
              {{ applyButtonText }}
              <!-- <v-icon size="x-small" class="ms-2">mdi-open-in-new</v-icon> -->
            </a>
          </div>
        </v-col>
        
      </v-row>
    </div>
  </section>
</template>

<script>
import NavIndicator from '@/components/partials/NavIndicator.vue';

export default {
  name: 'HeroSection',
  components: {  
    NavIndicator,
  },
  props: {
    subTitle: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    showWhiteWave: {
      type: Boolean,
      required: false,
      default: false,
    },
    showBlueWaves: {
      type: Boolean,
      required: false,
      default: false,
    },
    showBlueWaves3: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDarkerWave: {
      type: Boolean,
      required: false,
      default: false,
    },
    showPurpleWaves: {
      type: Boolean,
      required: false,
      default: false,
    },
    showLightBlueWaves: {
      type: Boolean,
      required: false,
      default: false,
    },
    imageName: {
      type: String,
      required: false,
    },
    hasButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonUrl: {
      type: String,
      required: false,
      default: '/',
    },
    buttonText: {
      type: String,
      required: false,
      default: 'default',
    },
    navIndicator: {
      type: Array,
      required: false,
      default: () => [],
    },
    reverseOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
    hardSkills: {
      type: Array,
      required: false,
      default: () => [],
    },
    department: {
      type: Array,
      required: false,
      default: () => [],
    },
    jobDetails: {
      type: Object,
      required: false,
      default: () => ({ type: '', workMode: '', location: '' }),
    },
    hasApplyButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    applyButtonUrl: {
      type: String,
      required: false,
      default: '/',
    },
    applyButtonText: {
      type: String,
      required: false,
      default: 'Apply Now',
    },
  },
};
</script>

<style scoped>
.section--hero {
  background-color: #f2f2f2;
  padding-top: 0rem;
  min-height: 400px;
  display: flex;
}
.nav-indicator {
  padding-left: 0.8rem;
  margin-bottom: 3rem;
}
.section__container {
  margin-top: 0;
  padding-block: 2rem;
  /* width: 100%; */
}

.section__subtitle {
  text-transform: capitalize;
  text-align: left;
  /* font-size: clamp(16px, 5vw, 28px) !important; */
  margin-bottom: 0.5rem;
  /* line-height: 1.2; */
}

.section__title {
  letter-spacing: 0%;
  line-height: 100%;
  text-align: left;
  font-size: clamp(20px, 5vw, 34px);
  color: #1a3c5e;
}

.section__title .title__arrow {
  width: clamp(16px, 2vw, 20px);
  height: clamp(16px, 2vw, 20px);
}

.section__title .title__text {
  color: #1a3c5e;
}

.section__description {
  text-align: left;
}

.section__image {
  width: 100%;
  max-width: clamp(350px, 40vw, 550px);
  max-height: clamp(200px, 30vw, 300px);
  object-fit: contain;
}

.job-post__tags {
  margin-block: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.job-post__skill-chip {
  margin-right: 0.5rem;
  /* color: #7c7979; */
}

.job-post__details {
  margin-block: 1rem;
  display: flex;
  gap: 3rem;
  color: var(--gray-1);
}

.job-post__detail {
  display: flex;
  align-items: center;
}

@media only screen and (min-width: 960px) {
  .text__container {
    width: 100%;
    /* margin-left: 3.5rem; */
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
}
@media only screen and (max-width: 960px) {
  .text__container {
    width: 90%;
    margin: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  .job-post__details {
    margin-block: 1rem;
    display: flex;
    gap: 1rem;
    color: var(--gray-1);
  }
  .section__title{
    text-align: center;
  }
  .section__description{
    text-align: center;
  }

  
}
@media only screen and (min-width: 1000px) {
  .text__container {
    width: 100%;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
}
@media only screen and (min-width: 1200px) {
  .text__container {
    width: 100%;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
}

.hero__btn {
  background-color: #007ab2;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 10px;
  transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;
}

.hero__btn:hover {
  background-color: #00aeff;
  transform: scale(1.05);
}
</style>